/*
 * @Author: Merlin
 * @Date: 2023-12-01 18:13:41
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-09 16:59:22
 * @Description:
 */
import {getServerSideTK, deCodeToken} from '@/stores/auth';
import useGlobalStore from '@/stores/global';

const aTopPage = ['/cn', '/']; // 首页地址
let isBacking = false;
let isPopstateNavigation = false; // 记录用户是否在执行"返回"
let lastState = {position: 0};

if (import.meta.client) {
    lastState = {...history.state};
    lastState.position ||= 1;
    // ↓ 监听地址变化，并做记录，用于后续判断
    window.addEventListener('popstate', function(oEv) {
        const {current, position: iNewPosition} = oEv.state; // 跳转目标
        const mark01 = lastState.position >= iNewPosition;
        // console.log(`方向信息：${lastState.position} >= ${iNewPosition} = ${mark01}`);
        // ↓ 前往 "非首页" 视为 backing
        isBacking = mark01 && !aTopPage.includes(current);
        isPopstateNavigation = true;
        (window as any).__isPopstateNav = true;
        (window as any).__isHistoryBack = mark01;
        setTimeout(() => {
            (window as any).__isPopstateNav = false;
            (window as any).__isHistoryBack = false;
        }, 0);
        lastState = {position: history.state.position};
        // console.log('[POP-DEBUG]', JSON.stringify({current, iNewPosition, mark01, isBacking, lastPos: lastState.position}));
    }, true);
}

const aOpenPage = [
    '/information',
    '/404',
];

// ↓ 监听全局的路由变化
// ↓ 经过测试这里的监听事件晚于上方的 popstate 事件触发
export default defineNuxtRouteMiddleware((to, from) => {
    if (0 && import.meta.dev){
        // 此处的打印比 default.vue 更早 
        console.log('中间件打印：🚩🚩🚩🚩🚩🚩🚩🚩🚩🚩\n', to);
    }
    const isThisBacking = isBacking;
    const isThisPopstate = isPopstateNavigation;
    isBacking = false; // ← 马上复位
    isPopstateNavigation = false;
    const isDev = import.meta.dev; // 开发环境标记
    const isClient = import.meta.client;
    // ▼ 仅在开发模式可以访问特定页
    if (to.path.includes('/_') && !isDev) {
        return abortNavigation();
    }
    // const sPath = useLocalePath()(sNoLogInPage);
    // const sPath = getLocalPath(sNoLogInPage);
    // ↑在中间件内使用以上2种方式都会导致报错，↓暂时按此法取得地址前缀 
    const sPathPrefix = getPathPrefix(to.path) == 'cn' ? '/cn' : '';
    if (isClient && !to.matched.length){ // 访问的地址不存在 
        console.log('目标地址不存在，已经重定向到 404; 目标地址：', to.path);
        return navigateTo({
            path: `${sPathPrefix}/404`,
            query: {
                from: encodeURIComponent(to.fullPath),
            },
        }, {
            redirectCode: 302,
        });
    }
    // ↓ 本地没有 token 判定为"未登录" 
    const noLogin = !getServerSideTK() && !deCodeToken();
    const sNoLogInPage = '/information?key=notLoggedIn';
    const toRedirect = (
        isClient
        && noLogin // 未登录
        // ↓ 表示页面加载完毕了（否则首次加载时的重定向工作让权给 default.vue 处理 
        && useGlobalStore().pageLoaded
        && !aOpenPage.some(cur => to.path.includes(cur)) // 不在开放页 
        && !checkIfViewingHistory(to, from) // 不在"游戏历史查看状态" 
    );
    isClient && console.log("未登录，需要重定向？", toRedirect);
    if (toRedirect){
        const sPath = sPathPrefix + sNoLogInPage;
        return navigateTo(sPath);
    }
    // ↓ 以下防止用户点击返回按钮离开首页 ------------------
    if (!isClient) return;
    const fromTop = aTopPage.includes(from.path);
    const toTop = aTopPage.includes(to.path);
    const fromTop2OtherPage = fromTop && !toTop;
    if (isThisBacking && fromTop2OtherPage) {
        showNegativeNotify({
            type: 'warning',
            i18n: 'commonInfo.noBacking',
        });
        return abortNavigation();
    }
    lastState = {position: history.state.position};
});


function getPathPrefix(path){
    let sLang = '';
    if (path.match(/^\/cn\b/)){
        sLang = 'cn'; // 地址栏"明确" 表示出当前语言
    }else if (import.meta.server){
        const cookie = useCookie('i18n_redirected');
        sLang = cookie.value;
    }else{
        sLang = useNuxtApp().$i18n.locale.value;
    }
    // console.log('sLang 分析结果➡️', sLang);
    return sLang || 'en';
}
